export const GET_CHECKOUT = "GET_CHECKOUT";
export const SET_CHECKOUT = "SET_CHECKOUT";

export const GET_CUSTOMCHECKOUT = "GET_CUSTOMCHECKOUT";
export const SET_CUSTOMCHECKOUT = "SET_CUSTOMCHECKOUT";
